import React from "react";
import { Link } from "react-router-dom";
import { SERVICES } from "@/lib/api";

export default function Footer() {
  return (
    <footer className="bg-black text-white mt-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <h3 className="font-display text-3xl font-black tracking-tight leading-none">
            Built for the<br/>seven daily<br/><span className="text-[#FF3333]">essentials.</span>
          </h3>
          <p className="text-white/60 text-sm mt-6 max-w-sm leading-relaxed">
            Twinstars Plaza is a multi-service marketplace bringing boxing, spa, gym, guesthouse, barbing, washing bay and laundry under one roof.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="label-eyebrow text-white/40 mb-4">Services</p>
          <ul className="space-y-2 text-sm">
            {SERVICES.map((s) => (
              <li key={s.key}>
                <Link to={`/services/${s.key}`} className="text-white/80 hover:text-white" data-testid={`footer-link-${s.key}`}>
                  {s.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="label-eyebrow text-white/40 mb-4">Company</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="text-white/80 hover:text-white">About</Link></li>
            <li><Link to="/jobs" className="text-white/80 hover:text-white">Careers</Link></li>
            <li><Link to="/contact" className="text-white/80 hover:text-white">Contact</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="label-eyebrow text-white/40 mb-4">Contact</p>
          <p className="text-sm text-white/80">info@twinstarsgh.com</p>
          <p className="text-sm text-white/80 mt-1">+233 24 000 0000</p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40 font-mono">© 2026 TWINSTARS PLAZA — ALL RIGHTS RESERVED.</p>
          <p className="text-xs text-white/40 font-mono">VERSION 1.0 / GMT+0</p>
        </div>
      </div>
    </footer>
  );
}
